// Copyright (c) 2016 Deere & Company

import allPartRequests from './all-part-requests';
import openPartRequests from './open-part-requests';
import partRequests from './part-requests';
import requestDetails from './request-details';
import search from './search';

export default {
    ...partRequests,
    childRoutes: [
        allPartRequests,
        openPartRequests,
        requestDetails,
        search
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/part-requests/open')
    }
};



// WEBPACK FOOTER //
// ./src/routes/part-requests/index.js